import React, { useState, useEffect } from 'react'
import axios from "axios";
import VideoPlayer from "../components/VideoPlayer";
import { ENV_CONFIG } from "../config/environment-unified";
import { Container } from "../layout/Container";
import styled from "styled-components";
import Avatar from "../components/Avatar";
import Modal from "../components/Modal";
import Button from "../components/Button";
import Dropdown from "../components/Dropdown";
import ReportModal from "../components/modals/Report";
import Tag from "../components/Tag";
// import landscapeVideo from "../img/tmp/lansscapeVideo.webm"
import Comments from "../components/Comments"
import Card from "../components/Cards";
import useTranslation from "../hooks/useTranslation";

// import { useParams } from "react-router-dom";

import { ReactComponent as MoreIcon } from "../img/icons/more.svg";
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";
// import avatar1 from "../img/tmp/avatars/1.png"
import { VideoCards } from "../TmpData";

export default function VideoPage() {
  // const { vidId } = useParams();
  // console.log(vidId)
  const [videoData, setvideoData] = useState({
    title: "",
    avatar: "",
    isLive: false,
    tags: [],
    username: "",
    verified: false,
    playbackLink: "", // <-- on ajoute ce champ
    description: "",
    gameName: "",
  });

  useEffect(() => {
    // Exemple avec /api/stream/mychannel/init
    axios.get(ENV_CONFIG.INIT_CHANNEL_ENDPOINT, { withCredentials: true })
      .then(res => {
        setvideoData(prev => ({
          ...prev,
          title: res.data.title,
          avatar: res.data.avatar,
          isLive: res.data.isLive,
          tags: res.data.tags,
          username: res.data.username,
          verified: res.data.verified,
          playbackLink: res.data.playbackLink, // <-- récupère l'URL IVS
          description: res.data.about,
          gameName: res.data.gameName,
        }));
      });
  }, []);

  return (
    <Cont style={{ width: "auto" }}>
      {/* <VideoPlayer
            // poster={data.videoThumbnail}
            type="rtmp/flv"
            // src={videoData.src}
            id="player-video"
            src={landscapeVideo}
            isLive={false}
            isMute={true}
            autoPlay={true}
            /> */}
      <VideoPlayer
        type="hls"
        id="player-video"
        src={videoData.playbackLink} // <-- utilise playbackLink ici
        isLive={videoData.isLive}
        isMute={true}
        autoPlay={true}
      />

      <Container>
        <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "row" }}>
          <div>
            <Header style={{ paddingTop: "15px" }}>
              <VideoTitle>{videoData.title}</VideoTitle>
              <Buttons title="d" />
            </Header>
            <Description setvideoData={(e) => setvideoData(e)} videoData={videoData} ></Description>
            <Comments />

          </div>
          <HorizontalCardCont>
            {VideoCards.map((card, index) => {
              return (
                <Card
                  to={card.to} // stream
                  game={card?.game}
                  avatar={card?.avatar}
                  state={card?.state}
                  thumbnailImg={card?.thumbnail}
                  gif={card?.gif}
                  timeStatus={card?.timeStatus}
                  title={card?.title}
                  userURL={card?.userURL} // profile
                  avatarImg={card?.avatar}
                  verified={card?.verified}
                  username={card?.username}
                  tournamentKind={card?.tournamentKind}
                  viewsCount={card?.viewerCount}
                  timePassed={card?.timePassed}
                  // tags={card?.tags}
                  key={index}
                />
              );
            })}

          </HorizontalCardCont>
        </div>

      </Container>
    </Cont>
  )
}


const Buttons = ({ title }) => {
  const { t } = useTranslation();
  const [shareModal, setShareModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [drop, setdrop] = useState(false);
  const VideoOptions = [
    {
      type: 2,
      title: t('common.report'),
      icon: null,
      func: () => setReportModal(true),
    },
  ];

  return (
    <ButtonsStyle>

      {/* <ViewsCounter socketRef={socketRef} streamData={streamData} />
        
        <FollowUnfollow channelId={streamData._id} followed={streamData.isFollowed} /> */}
      <div
        onClick={() => {
          setdrop(!drop);
        }}
        style={{ position: "relative" }}
      >
        <Button icon>
          <MoreIcon />
        </Button>
        {drop && (
          <Dropdown
            show={drop}
            setShow={() => {
              setdrop(!drop);
            }}
            style={{ right: "-100%", top: "100%" }}
            options={VideoOptions}
            margin="10px"
          />
        )}
      </div>
      <Modal
        isOpen={shareModal}
        onRequestClose={() => setShareModal(false)}
        hideModal={() => setShareModal(false)}
      >
        {/* <ShareStreamModal shareURL={"https://www.ayourlab.com/stream/" + streamData.username} /> */}
      </Modal>
      <Modal
        isOpen={reportModal}
        onRequestClose={() => setReportModal(false)}
        hideModal={() => setReportModal(false)}
      >
        <ReportModal id={"video"} />
      </Modal>
    </ButtonsStyle>
  );
};

const Description = ({ videoData, ...rest }) => {
  // const streamData = useSelector(state => state.stream.data)

  return (
    <DescriptionStyle {...rest}>
      <div>
        <Avatar
          to={videoData.username}
          src={videoData.avatar}
          alt={videoData.username}
          size="53px"

        />
        <div>
          <span>
            {videoData.username}
            {videoData.verified && <VerifiedIcon />}
          </span>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <div className="small">{videoData.gameName}</div>

            {videoData.tags?.map((tag, index) => {

              return (
                <Tag to={"/tags/" + tag} key={index} style={{ marginRight: "4px" }}>
                  {tag}
                </Tag>
              );
            })}
          </div>

        </div>
      </div>
      <p>{videoData.description}</p>
    </DescriptionStyle>

  );
};


const DescriptionStyle = styled.article`
  margin-top: 10px;

  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-bottom: 50px;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  margin-bottom: 50px;
  flex-direction: column;
  /* > div:nth-child(1) {
    margin-right: 20px;
  } */

  > div:nth-child(1) {
    /* flex: 1; */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-items: center;
    > div{
        h4 {
            word-break: break-all;
            ${({ theme }) => theme.linesLimits(3, 1.2)}
        }
        > span {
            font-size: 19px;
        font-family: "Poppins Medium";
        font-weight: 500;
        margin-bottom: 3px;
        margin-top: 20px;
        text-transform: capitalize;
        line-height: 100%;
        svg {
            position: relative;
            left: 6px;
            top: 1px;
        }
        }
        >div{
            margin-top: 3px;
        }
    }

   
    &>div{
        font-family: "Poppins Regular";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        margin-right: 20px;
        color : ${({ theme }) => theme.color.darkerText};

    }

  }
`;



const ButtonsStyle = styled.div`
 
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    margin-bottom: 24px;
    ${({ theme }) => theme.gap("10px")}
    >small {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: ${({ theme }) => theme.color.primaryText};
      font-family: "Poppins Regular";
      letter-spacing: 1px;
    }
    svg {
      circle {
        fill: ${({ theme }) => theme.color.primaryText};
      }
    }
    svg {
      path {
        stroke: ${({ theme }) => theme.color.primaryText};
        fill: none;
      }
    }
    :hover {
      svg {
        path {
          stroke: ${({ theme }) => theme.color.primaryText};
          fill: none;
        }
      }
    }
  `;


const VideoTitle = styled.div`
 
    
  display: flex;
  /* flex: 1; */
  font-family: "Poppins Bold";
    font-size: 27px;
    /* line-height: 120%; */
    display: flex;
    /* align-items: center; */
    max-width: 800px;
    color : ${({ theme }) => theme.color.darkerText};
    @media only screen and (max-width: 576px) {
        font-size: 20px;

    }



`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content : space-between;

`;
const Cont = styled.div`


    /* height: calc(100vh - 140px);   */
            max-height: calc(100vh -100px);

        @media only screen and (max-width: 576px) {
            height: calc(100vh - 140px); 
            /* max-height: calc(100vh -100px); */
    } 
`

const HorizontalCardCont = styled.div`
    margin-top: 28px;
    
      display: flex;
    flex-direction: column;
    align-items: center;

`;